export default "__VITE_ASSET__rF55AlXz__"